import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/_services/app.service";

@Component({
  selector: "app-version",
  templateUrl: "./version.component.html",
  styleUrls: ["./version.component.scss"],
  standalone: false,
})
export class VersionComponent implements OnInit {
  version: {
    version: string;
    build: string;
    year: string;
  } = {
    version: "",
    build: "",
    year: "",
  };

  constructor(private appService: AppService) {
    this.initVersion();
  }
  initVersion() {
    this.appService.getBuildVersion().subscribe((v: any) => {
      let fullYear = new Date().getFullYear();

      this.version = {
        ...v,
        year: fullYear,
      };
    });
  }
  ngOnInit() {}
}
